const speed = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5] as const;
// speed[x]    0, 1,    2,   3,    4,   5,    6,   7,    8,   9,    10
export default speed;
